module.exports = __webpack_public_path__ + "static/w-selena-cc4c3ee5a8ea8052b2f073acbfc236d3.jpg";